import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import { AgGridLoadingOverlayComponent } from '../../Common/AgGrid/agGridLoadingOverlay.component';
import { BusyIndicatorModule } from '../../Busy-Indicator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { TaxAccessSyncLogService } from './taxAccessSyncLog.service';
import { TaxAccessSyncLogRepository } from './taxAccessSyncLog.repository';
import { TaxAccessSyncLogListComponent } from './Tax-Access-Sync-Log-List/taxAccessSyncLogList.component';
import { TaxAccessSyncLogListGridActionCellRendererComponent } from './Tax-Access-Sync-Log-List/agGridActionCellRenderer.component';
import { TaxAccessSyncLogDetailsModalComponent } from './Tax-Access-Sync-Log-Details/taxAccessSyncLogDetailsModal.component';
import { TaxAccessSyncLogDetailsGridComponent } from './Tax-Access-Sync-Log-Details/taxAccessSyncLogDetailsGrid.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WeissmanSharedModule,
        SharedPipesModule,
        BusyIndicatorModule.forRoot(),
        AgGridExtensionsModule,
        AgGridModule
    ],
    declarations: [
        TaxAccessSyncLogListComponent,
        TaxAccessSyncLogListGridActionCellRendererComponent,
        TaxAccessSyncLogDetailsModalComponent,
        TaxAccessSyncLogDetailsGridComponent
    ],
    providers: [
        TaxAccessSyncLogService,
        TaxAccessSyncLogRepository
    ],
    exports: []
})
export class TaxAccessSyncLogModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('taxAccessSyncLogList', TaxAccessSyncLogListComponent);
        hybridAdapterUtility.downgradeNg2Component('taxAccessSyncLogDetails', TaxAccessSyncLogDetailsModalComponent);
        hybridAdapterUtility.downgradeNg2Component('taxAccessSyncLogDetailsGrid', TaxAccessSyncLogDetailsGridComponent);
    }
}
